/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DocumentAction {
    Unknown = 0,
    FixInProgress = 1,
    ReadyReupload = 2,
    ReadyResolved = 3,
    ReadyOther = 4
}

export function DocumentActionFromJSON(json: any): DocumentAction {
    return DocumentActionFromJSONTyped(json, false);
}

export function DocumentActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentAction {
    return json as DocumentAction;
}

export function DocumentActionToJSON(value?: DocumentAction | null): any {
    return value as any;
}

